import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5ea9d54e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "common-service-popup"
};
const _hoisted_2 = {
  class: "popup-main"
};
const _hoisted_3 = {
  class: "popup-header"
};
const _hoisted_4 = {
  class: "popup-title"
};
const _hoisted_5 = {
  class: "close-wrap flex justify-center"
};
const _hoisted_6 = {
  class: "popup-content"
};
const _hoisted_7 = {
  class: "service-list-wrap"
};
const _hoisted_8 = {
  class: "service-icon"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "status-dot"
}, null, -1));
const _hoisted_10 = {
  class: "service-label"
};
const _hoisted_11 = {
  class: "service-icon"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "status-dot"
}, null, -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "service-label"
}, "Facebook", -1));
const _hoisted_14 = {
  class: "service-icon"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "status-dot"
}, null, -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "service-label"
}, "Telegram", -1));
const _hoisted_17 = {
  key: 0,
  class: "service-item large margin-bottom-0"
};
const _hoisted_18 = {
  class: "service-label"
};
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useHelpTool } from '@/hooks';
import { useUserStore, useSettingsStore, usePopupStore } from '@/store';
export default {
  __name: 'Service',
  props: ['show'],
  emits: ['onClose'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const {
      copy,
      openBrowser
    } = useHelpTool();
    const userStore = useUserStore();
    const settingsStore = useSettingsStore();
    const {
      invitationCode
    } = storeToRefs(userStore);
    const {
      onlineService,
      facebookUrl,
      telegramUrl
    } = storeToRefs(settingsStore);
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_popup = _resolveComponent("van-popup");
      const _directive_audio = _resolveDirective("audio");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_popup, {
        show: __props.show,
        position: "right",
        "close-on-click-overlay": false,
        "lock-scroll": false
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('livechat.customerService')), 1), _createElementVNode("div", _hoisted_5, [_withDirectives(_createVNode(_component_van_image, {
          class: "close-icon",
          src: require('@/assets/img/common/close.png'),
          onClick: _cache[0] || (_cache[0] = $event => emit('onClose'))
        }, null, 8, ["src"]), [[_directive_audio, void 0, "close"]])])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
          class: "service-item",
          onClick: _cache[1] || (_cache[1] = $event => _unref(openBrowser)(_unref(onlineService)))
        }, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_van_image, {
          fit: "cover",
          src: require('@/assets/img/livechat/service.png')
        }, null, 8, ["src"]), _hoisted_9]), _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('livechat.onlineService')), 1)]), _createElementVNode("div", {
          class: "service-item",
          onClick: _cache[2] || (_cache[2] = $event => _unref(openBrowser)(_unref(facebookUrl)))
        }, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_van_image, {
          fit: "cover",
          src: require('@/assets/img/livechat/facebook.png')
        }, null, 8, ["src"]), _hoisted_12]), _hoisted_13]), _createElementVNode("div", {
          class: "service-item",
          onClick: _cache[3] || (_cache[3] = $event => _unref(openBrowser)(_unref(telegramUrl)))
        }, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_van_image, {
          fit: "cover",
          src: require('@/assets/img/livechat/telegram.png')
        }, null, 8, ["src"]), _hoisted_15]), _hoisted_16]), _unref(invitationCode) ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, "ID: " + _toDisplayString(_unref(invitationCode)), 1), _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "copy-btn",
          onClick: _cache[4] || (_cache[4] = $event => _unref(copy)(_unref(invitationCode)))
        }, [_createTextVNode(_toDisplayString(_ctx.$t('common.copy')), 1)])), [[_directive_audio]])])) : _createCommentVNode("", true)])])])]),
        _: 1
      }, 8, ["show"])]);
    };
  }
};